<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">账号设置</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <div class="posi-avatar">
          <div class="avatar-img">
            <el-upload
              class="avatar-uploader"
              :action="uploadimg"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :on-progress="handleProgress"
            >
              <img
                v-if="fromData.headimage"
                :src="urls + fromData.headimage"
                class="avatar"
              />
              <img
                v-else
                class="mo"
                src="@/assets/images/header/avatar.png"
                alt=""
              />
              <div v-if="showProgress" class="progress-wrapper">
                <el-progress
                  :percentage="percentage"
                  type="circle"
                  class="progress"
                ></el-progress>
              </div>
            </el-upload>
          </div>
          <div class="avatar-text">头像</div>
        </div>
        <div class="posi-from">
          <!-- <div class="posi-item">
            <div class="posi-item-title">登录账号</div>
            <div class="posi-item-input">
              <el-input placeholder="请输入"></el-input>
            </div>
          </div> -->
          <!-- <div class="posi-item">
            <div class="posi-item-title">门店名称</div>
            <div class="posi-item-input">
              <el-input placeholder="请输入"></el-input>
            </div>
          </div> -->
          <div class="posi-item">
            <div class="posi-item-title">姓名</div>
            <div class="posi-item-input">
              <el-input v-model="fromData.name" placeholder="请输入"></el-input>
            </div>
          </div>
          <!-- <div class="posi-item">
            <div class="posi-item-title">门店地址</div>
            <div class="posi-item-input">
              <el-cascader
                size="large"
                :options="options"
                v-model="county"
                @change="handleChange"
                placeholder="请选择省市区"
                style="width: 100%"
              ></el-cascader>
            </div>
          </div> -->
          <div class="posi-item">
            <div class="posi-item-title">手机号码</div>
            <div class="posi-item-input">
              <el-input
                v-model="fromData.phone"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <!-- <div class="posi-item">
            <div class="posi-item-title">详细地址</div>
            <div class="posi-item-input">
              <el-input placeholder="请输入"></el-input>
            </div>
          </div> -->
        </div>
      </div>

      <div class="posi-btn">
        <div @click="handleSubmit">保存</div>
      </div>
    </div>
  </div>
</template>
<script>
import { regionData, codeToText } from "element-china-area-data";
export default {
  name: "AccountSettings",
  props: ["dataVal"],
  data() {
    return {
      options: regionData,
      county: "",
      fromData: {
        name: "",
        phone: "",
        headimage: "",
      },
      percentage: 0,
      showProgress: false,
      urls: this.imgurl,
      headers: {
        type: window.localStorage.getItem("type"),
        token: window.localStorage.getItem("token"),
      },
    };
  },
  mounted() {
    let i2 = "";
    let arr = [...regionData]
    regionData.forEach((item, i) => {
      if (item.label == "福建省") {
        i2 = i;
        regionData.splice(i, 1);
        return false;
      }
    });
    regionData.unshift(arr[i2]);
  },
  methods: {
    handleProgress(event, file, fileList) {
      this.showProgress = true;
      this.percentage = Math.floor((event.loaded / event.total) * 100);
    },
    //提交
    async handleSubmit() {
      let res = await this.$api.indexEditinfo({
        ...this.fromData,
      });
      if (res.code == 1) {
        let obj = {
          flag: false,
          submitFlag: true,
        };
        this.$emit("accountSettingsCell", obj);
      }
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("accountSettingsCell", obj);
    },
    //上传头像
    handleAvatarSuccess(res, file) {
      this.fromData.headimage = res.data.imgsrc;
      this.showProgress = false;
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
    },
    //省市区选择
    handleChange(value) {
      console.log(value); //打印出城市code值
      this.getCodeToText(value); //转换城市名称方法
    },
    //转换城市名称方法
    getCodeToText(val) {
      let cityNmae = "";
      switch (val.length) {
        case 1:
          cityNmae += codeToText[val[0]];
          break;
        case 2:
          cityNmae += codeToText[val[0]] + "/" + codeToText[val[1]];
          break;
        case 3:
          cityNmae +=
            codeToText[val[0]] +
            "/" +
            codeToText[val[1]] +
            "/" +
            codeToText[val[2]];
          break;
        default:
          break;
      }
      console.log(cityNmae);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if (newVal.flag) {
          this.fromData.name = newVal.userinfo.name;
          this.fromData.phone = newVal.userinfo.phone;
          this.fromData.headimage = newVal.userinfo.headimage;
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}

.posi-center {
  width: 1016px;
  //height: 80vh;
  border-radius: 25px;
  background-color: #fff;
  padding-bottom: 40px;
  .posi-head {
    padding: 32px 64px 0 42px;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 28px;
      color: #606060;
      cursor: pointer;
    }
  }
  .posi-over {
    //height: calc(80vh - 235px);
    overflow: auto;
  }
  .posi-avatar {
    margin-bottom: 40px;
    .mo {
      width: 80px;
      height: 80px;
    }
    .avatar-uploader {
      position: relative;
    }
    .avatar-img {
      width: 80px;
      height: 80px;
      margin: 0 auto;
    }
    .avatar-text {
      text-align: center;
      font-size: 14px;
      color: #4379ee;
    }
    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    /deep/.progress-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(0,0,0,.2);
      border-radius: 50%;
      .el-progress-circle {
        width: 80px !important;
        height: 80px !important;
      }
    }
    .progress {
      width: 80px;
    }
  }
  .posi-from {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .posi-item {
      width: 360px;
      margin-right: 60px;
      margin-bottom: 60px;
      .posi-item-title {
        color: #606060;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 11px;
      }
      .posi-item-input {
        width: 100%;
        input {
          width: 100%;
          height: 52px;
          background-color: #f5f6fa;
          color: #333;
          font-size: 14px;
          border: 1px solid #d5d5d5;
          outline: none;
          padding-left: 16px;
        }
        /deep/.el-input__inner {
          height: 52px;
          line-height: 52px;
          background-color: #f5f6fa;
          color: #333;
          font-size: 14px;
          border: 1px solid #d5d5d5;
        }
      }
    }
    .posi-item:nth-child(2n) {
      margin-right: 0;
    }
    .posi-item:nth-last-child(1),
    .posi-item:nth-last-child(2) {
      margin-bottom: 0;
    }
  }
  .posi-btn {
    padding-top: 60px;
    div {
      width: 274px;
      height: 56px;
      background-color: #4880ff;
      border-radius: 12px;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      @include flex-center(center, center);
      margin: 0 auto;
      cursor: pointer;
    }
  }
}
</style>